import React, { FC } from 'react';
import { useSignal } from '@funtech-int/rival-react';
import { usePopupsManager } from '@funtech-int/web-toolkit';
import { createPortal } from 'react-dom';

import { isContentModal, isModal, isPaymentWidget, isToast } from '../../lib/popups';
import { ToastNotification } from '../ToastNotification/ToastNotification';
import { Modal } from '../Modal/Modal';
import { ContentModal } from '../ContentModal/ContentModal';
import { PaymentWidgetModal } from '../PaymentWidgetModal/PaymentWidgetModal';

export const Popups: FC = () => {
    const popupsManager = usePopupsManager();

    const popups = useSignal(popupsManager.popups);

    return createPortal(
        popups.map((popup) => {
            if (isToast(popup)) {
                return (
                    <ToastNotification
                        key={popup.key ?? popup.id}
                        type={popup.payload.type}
                        viewVariant={popup.payload.viewVariant}
                        message={popup.payload.message}
                        showTime={popup.payload.showTime}
                        onHide={() => popupsManager.hide(popup.id)}
                    />
                );
            }
            if (isModal(popup)) {
                return (
                    <Modal
                        key={popup.key ?? popup.id}
                        className={popup.payload.className}
                        closeButtonClassName={popup.payload.closeButtonClassName}
                        onHideModal={() => {
                            popup.payload.onClose?.();
                            popupsManager.hide(popup.id);
                        }}
                    >
                        {popup.payload.content}
                    </Modal>
                );
            }
            if (isContentModal(popup)) {
                return (
                    <ContentModal
                        key={popup.key ?? popup.id}
                        id={popup.id.toString()}
                        className={popup.payload.className}
                        overlayClassName={popup.payload.overlayClassName}
                        closeIcon={popup.payload.closeIcon}
                        rounded={popup.payload.rounded}
                        fullscreen={popup.payload.fullscreen}
                        colorScheme={popup.payload.colorScheme}
                        onHideModal={() => {
                            popup.payload.onClose?.();
                            popupsManager.hide(popup.id);
                        }}
                    >
                        {popup.payload.content}
                    </ContentModal>
                );
            }
            if (isPaymentWidget(popup)) {
                return (
                    <PaymentWidgetModal key={popup.key ?? popup.id} start={popup.payload.start} />
                );
            }
            return null;
        }),
        document.body
    );
};
